import { DataAction, Payload, Persistence, StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Injectable } from '@angular/core';
import { Selector, State, Store } from '@ngxs/store';
import { produce } from 'immer';
import { RoleNames } from 'src/app/models/role';

import { BrowserListenerEvent } from '../browser-communication/browser-communication.models';
import { BrowserCommunicationService } from '../browser-communication/browser-communication.service';
import { RoleStateModel } from './user.state.models';

@Persistence()
@StateRepository()
@State<RoleStateModel>({
    name: 'roleState',
    defaults: {

    },

})
@Injectable()
export class RoleService extends NgxsDataRepository<RoleStateModel> {


    @Selector()
    static currentRoleName(state: RoleStateModel) {
        return state.currentRoleName;
    };

    constructor(
        private readonly store: Store,
        private readonly commService: BrowserCommunicationService
    ) {
        super();
    }


    ngxsAfterBootstrap() {

        this.commService.addListener(((event: MessageEvent) => {
            const data = event.data as BrowserListenerEvent;
            if (data && data.type === 'role') {
                this.ctx.setState(data.data);
            }
        }).bind(this));

    }

    @DataAction()
    async setCurrentRole(@Payload('selectedRole') value: string) {
        this.ctx.setState(produce(this.ctx.getState(), (draft: RoleStateModel) => {
            draft.currentRoleName = value as RoleNames;
        }));

        this.commService.postMessage({ type: 'role', name: 'CHANGED', data: this.ctx.getState() });

    }

}
